export default __webpack_public_path__ + "static/media/disco@3x.776ef6e7.png";